import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAsync, postAsync, putAsync } from '../../../../components/helper/axiosHelper';
import { handleApprovalLetterDownload, handleDeadCertificateDownload, handleFileDownload } from '../../../../libs';
import { PageHitCountApi } from '../../../../shared/Helper';
import { DetailAccordion } from '../../../external/service/sd/DetailAccordion';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import './sDProjectApproval.scss';

const SDProjectApproval = () => {
  const { id } = useParams();
  const [apiData, setApiData] = useState([]);
  const [serviceDeadID, setServiceDeadID] = useState(0);
  const [eP_ID, setEP_ID] = useState([]);
  const [eP_DeadCertificateDoc, setEP_DeadCertificateDoc] = useState([]);
  const [eP_ApprovalLetterDoc, setEP_ApprovalLetterDoc] = useState([]);
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [maNotes, setMaNotes] = useState('');
  const [reason, setReason] = useState('');
  const [selectedEP_IDImageData, setSelectedEP_IDImageData] = useState(null);
  const [selectedDeadCertificateImageData, setSelectedDeadCertificateImageData] = useState(null);
  const [selectedApprovalLetterImageData, setSelectedApprovalLetterImageData] = useState(null);
  const [deadCertificate, setDeadCertificate] = useState('');
  const [approvalLetter, setApprovalLetter] = useState('');
  const [mediaData, setMediaData] = useState([]);
  const [limitRequest, setLimitRequest] = useState(true);
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [ProjectName, setProjectName] = useState(false);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation()

  const token = localStorage.getItem('token');
  const epUser = localStorage.getItem('apid');
  const isLogin = () => {
    if (!token) {
      navigate('/managementLogin');
    }
  };

  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, [])

  useEffect(() => {
    localStorage.setItem('isHome', false);
    isLogin();
    getData();
  }, []);

  const getData = async () => {
    try {
      setIsLoading(true);
      const response = await getAsync('ServiceDead/GetSDByIDAsync/', { id: id });

      if (response.statusCode === 200) {
        setIsLoading(false);
        const result = response?.data[0];
        setProjectName(result?.newProjectName);
        setMediaData(result?.archiveMediaModelList);
        setEP_ID(result?.epUserID);
        setApiData(result);
      } else {
        setIsLoading(false);
        toast.error(t('Something went wrong, Please try again!'));
      }
    } catch (error) {
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const validate = () => {
    let result = true;
    if (password === '' || password === null) {
      result = false;
      toast.warning(`${t('msg_pleaseEnter')}` + `${t('password')}`);
    }
    return result;
  };

  var localeDateTime = new Date();
  const bodyApprove = {
    ePUserID: eP_ID,
    serviceDeadID: parseInt(serviceDeadID),
    maID: parseInt(epUser),
    userId: epUser,
    maApproveID: 1,
    ProjectName,
    maDate: localeDateTime,
    maNotes: maNotes,
    reason,
    password: password,
    activeID: 1,
  };



  const handleApprove = async (e) => {
    e.preventDefault();
    if (validate) {
      setIsLoading(true);
      await putAsync('ServiceDead/SDApproval/', bodyApprove, { id: id })
        .then((response) => {
          if (response?.statusCode === 200) {
            setIsLoading(false);
            handleProjectCreate();
          } else {
            setIsLoading(false);
            toast.error(`${t('Password failed Please try Again')}`);
          }
        })
        .catch((err) => {
          toast.error(t('Something went wrong, Please try again!'));
        });
    }
  };

  const createBody = {
    donorName: apiData?.applicantName,
    donorMobile: apiData?.applicantMobile,
    projectName: apiData?.newProjectName,
    selectedProjectId: apiData?.projectID,
    arabSeaID: +id,
  };
  const handleProjectCreate = async () => {
    await postAsync('APIClient/SDProjectCreateAndPublish', createBody)
      .then((res) => {
        toast.success(`${t('This record has been approved')}`);
        getData();
        navigate('/SDPublishProjectList');
      })
      .catch((err) => {
        toast.error(`${t('Password failed Please try Again')}`);
      });
  };
  const bodyDisapprove = {
    ePUserID: eP_ID,
    serviceDeadID: parseInt(serviceDeadID),
    maID: parseInt(epUser),
    maApproveID: 2,
    maDate: localeDateTime,
    maNotes: maNotes,
    reason,
    ProjectName: apiData?.newProjectName,
    password: password,
    userId: epUser,
    activeID: 2,
  };

  const handleDisapprove = async (e) => {
    e.preventDefault();
    if (validate) {
      setIsLoading(true);
      await putAsync('ServiceDead/SDApproval/', bodyDisapprove, { id: id })
        .then((response) => {
          if (response?.statusCode === 200) {
            setIsLoading(false);
            toast.success(`${t('This record has been Disapproved')}`);
            getData();
            navigate('/SDProjectApprovalList');
          } else {
            setIsLoading(false);
            toast.error(`${t('Password failed Please try Again')}`);
          }
        })
        .catch((err) => {
          toast.error(t('Something went wrong, Please try again!'));
        });
    }
  };

  const openModal = (e) => {
    e.preventDefault();
    setGridModalOpen(true);
  };

  const closeModal = (e) => {
    e.preventDefault();
    setGridModalOpen(false);
  };

  const handleDocLoad = async (e) => {
    e.preventDefault();
    await getData();
    setLimitRequest(false);
  };



  return (
    <>
      <div className="flex justify-center py-5 mt-3 ">
        <form className="container mx-auto">
          <div className="shadow-md  rounded-md">
            <div className="card-header p-2">
              <h1 className="font-bold sm:text-2xl text-center text-xl text-customgreen">
                {t('Service For Dead Project Approval')}
              </h1>
            </div>
            {isLoading ? (
              <LoadingAnimation />
            ) : (
              <>
                <div className="card-body md:p-10">
                  <div className="row ">
                    <div className="col-lg-12">
                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Details')}</h2>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography></Typography>
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="form-group">
                                <label
                                  className="text-gray-700 p-2 font-semibold text-pretty text-sm"
                                  htmlFor="deadName"
                                >
                                  {t('Name of Dead Person')}
                                  <span className="errmsg">*</span>
                                </label>
                                <input
                                  name="deadName"
                                  value={apiData.deadName}
                                  type="text"
                                  disabled
                                  style={{
                                    backgroundColor: 'lightgray',
                                    fontWeight: '600',
                                    cursor: 'no-drop',
                                  }}
                                  className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  minLength="1"
                                  maxLength="50"
                                />
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-group">
                                <label className="text-gray-700 p-2 font-semibold text-pretty text-sm">
                                  {t('Project Name')}
                                  <span className="errmsg">*</span>
                                </label>
                                <input
                                  value={apiData?.newProjectName}
                                  disabled
                                  style={{
                                    backgroundColor: 'lightgray',
                                    fontWeight: '600',
                                    cursor: 'no-drop',
                                  }}
                                  type="text"
                                  className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  minLength="1"
                                  maxLength="100"
                                />
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-group">
                                <label className="text-gray-700 p-2 font-semibold text-pretty text-sm">
                                  {t('Relationship')}
                                  <span className="errmsg">*</span>
                                </label>
                                <input
                                  value={t(`${apiData?.relationName}`)}
                                  disabled
                                  style={{
                                    backgroundColor: 'lightgray',
                                    fontWeight: '600',
                                    cursor: 'no-drop',
                                  }}
                                  type="text"
                                  className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  minLength="1"
                                  maxLength="50"
                                />
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-group">
                                <label className="text-gray-700 p-2 font-semibold text-pretty text-sm">
                                  {t('Applicant Mobile')}
                                  <span className="errmsg">*</span>
                                </label>
                                <input
                                  value={apiData?.applicantMobile}
                                  disabled
                                  style={{
                                    backgroundColor: 'lightgray',
                                    fontWeight: '600',
                                    cursor: 'no-drop',
                                  }}
                                  type="text"
                                  className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  minLength="1"
                                  maxLength="20"
                                />
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-group">
                                <label className="text-gray-700 p-2 font-semibold text-pretty text-sm">
                                  {t('Applicant Name')}
                                  <span className="errmsg">*</span>
                                </label>
                                <input
                                  value={apiData?.applicantName}
                                  disabled
                                  style={{
                                    backgroundColor: 'lightgray',
                                    fontWeight: '600',
                                    cursor: 'no-drop',
                                  }}
                                  type="text"
                                  className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  minLength="1"
                                  maxLength="50"
                                />
                              </div>
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                      <br />

                      <DetailAccordion
                        limitRequest={limitRequest}
                        handleDocLoad={handleDocLoad}
                        mediaData={mediaData}
                        handleFileDownload={handleFileDownload}
                        eP_ID={eP_ID}
                        openModal={openModal}
                        gridModalOpen={gridModalOpen}
                        setGridModalOpen={setGridModalOpen}
                        t={t}
                        closeModal={closeModal}
                        selectedEP_IDImageData={selectedEP_IDImageData}
                        deadCertificate={deadCertificate}
                        handleEP_DeadCertificateDownload={handleDeadCertificateDownload}
                        eP_DeadCertificateDoc={eP_DeadCertificateDoc}
                        selectedDeadCertificateImageData={selectedDeadCertificateImageData}
                        approvalLetter={approvalLetter}
                        handleEP_ApprovalLetterDownload={handleApprovalLetterDownload}
                        eP_ApprovalLetterDoc={eP_ApprovalLetterDoc}
                        selectedApprovalLetterImageData={selectedApprovalLetterImageData}
                        title={'Document Details'}
                      />
                      <br />

                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Extra')}</h2>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography></Typography>
                          <div className="col-lg-12">
                            <div className="form-group">
                              <label className="text-gray-700 p-2 font-semibold text-pretty text-sm">
                                {t('Managed Notes')}
                                 {/* <span className="errmsg">*</span> */}
                              </label>
                              <textarea
                                style={{ height: '100px' }}
                                value={apiData?.maNotes}
                                onChange={(e) => setMaNotes(e.target.value)}
                                className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                minLength="1"
                                maxLength="500"
                              />
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-group">
                              <label className="text-gray-700 p-2 font-semibold text-pretty text-sm">
                                {t('Reason')}
                                 {/* <span className="errmsg">*</span> */}
                              </label>
                              <textarea
                                style={{ height: '100px' }}
                                value={apiData?.reason}
                                onChange={(e) => setReason(e.target.value)}
                                className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                minLength="1"
                                maxLength="500"
                              />
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                      <br />

                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          {/* <Typography style={{ fontWeight: 'bold', fontSize: '18px' }}>
                              {t('Confirmation')}
                            </Typography> */}
                          <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Confirmation')}</h2>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography></Typography>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label className="text-gray-700 p-2 font-semibold text-pretty text-sm">
                                {t('Password')}
                                <span className="errmsg">*</span>
                              </label>
                              <input
                                value={password}
                                type="password"
                                onChange={(e) => setPassword(e.target.value)}
                                className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                minLength="1"
                                maxLength="50"
                              />
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  </div>
                </div>
                <div className="card-footer flex flex-wrap justify-center gap-2 xss:py-5">
                  <button
                    type="submit"
                    onClick={handleApprove}
                    className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-8 py-2.5 text-center me-1"
                  >
                    {t('Approve')}
                  </button>

                  <button
                    type="submit"
                    onClick={handleDisapprove}
                    className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-8 py-2.5 text-center me-1"
                  >
                    {t('Disapprove')}
                  </button>

                  <Link
                    to={'/SDProjectApprovalList'}
                    className="text-white w-32 bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-3 py-2.5 text-center me-1"
                  >
                    {t('Back')}
                  </Link>
                </div>
              </>
            )}
          </div>
        </form>
      </div>
    </>
  );
};

export default SDProjectApproval;
